import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import { withFirebase } from "../../components/Firebase";
import { handleGetPrivacyPolicy } from "../../constants/termsPrivacy";

import "./index.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-main-container privacy-mobile-cotainer">
      <div className="privacy-second-section">
        <Container>
          <div className="meeting-section second-sec-desc"></div>
        </Container>
      </div>

      <div className="thard-section privacy-container privacy-second-main-container">
        <Container>
          <div className="privacy-description">
            <Row className="privacy-title-row">
              <Col lg={6}>
                <div className="privacy-title">Privacy Policy</div>
              </Col>
            </Row>
            <Row>
              <Col dangerouslySetInnerHTML={handleGetPrivacyPolicy()}></Col>
            </Row>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default compose(withRouter, withFirebase)(PrivacyPolicy);
